define('views/shared/accounts/accounts',[
	'backbone',
	'models/accounts/accounts',
    'models/accounts/allocations',
    'models/causes/allocation'
], function(Backbone, AccountsModel, AllocationsModel, AllocationModel){
    'use strict';

    var AccountsContoller = Backbone.View.extend({
        data: null,
        savings: [],
        accounts: null,
        allocations: [],
        manage_allocations: [],
        spending_account: null,

    	initialize: function(options){
    		this.accounts = new AccountsModel({ instanceURL: pf.url + '/Accounts/V2/' });
    	},

    	get: function(callback, account_id){
    		var that = this;

    		this.accounts.fetch({
                success: function(model, response){

                	if(response){
                        
                        that.data = response;

                        that.savings = [];

                		for(var i = 0; i < response.length; i++){
	                    	var account = response[i];

	                    	if(account.account_type_id == enums.accountTypeEnum.GeneralFund){
	                            that.spending_account = account;
	                        } else {
	                        	that.savings.push(account);
	                        }

                            if(account_id && account_id == account.account_id){
                                var desired_account = account;
                            }

	                    }

	                    // TODO: Move this logic out of here
                        if(that.spending_account && pf.balance){
                            pf.balance.updateData(that.spending_account);
                        }

                        if(_.isFunction(callback) && that.data){

                            if(account_id){
                                callback(desired_account, that.spending_account, that.savings);
                            } else {
                                callback(that.spending_account, that.savings);
                            }
                            
                        } else {
                            // TODO: Implement a check back to persistence
                            // that.checkback
                        }
	                    
                	} else {

                		if(_.isFunction(callback)){
	                    	callback(false);
	                    }

                	}

                },
                error: function(err){

                    if(_.isFunction(callback)){
                    	callback(false);
                    }

                }
            });
            
    	},

        createAccount: function(data){
            this.new_account = new AccountsModel({ instanceURL: pf.url + '/Accounts/V2/' });

            // this.new_account.save();
        },

    	update: function(){},

        getAccount: function(account_id, load_fresh, callback){

            // Go to the server to get Account
            if(load_fresh || !this.allocations){

                this.get(function(account, spending_account, savings){

                    if(_.isFunction(callback)){
                        callback(account, spending_account, savings);
                    }

                }, account_id);

            } else {
                var accounts = this.data;

                for(var i = 0; i < accounts.length; i++){
                    var account = accounts[i];

                    if(account.account_id == account_id){
                        has_account = true;

                        if(_.isFunction(callback)){
                            callback(account, this.spending_account, this.savings);
                        }

                    }

                }

                if(!has_account && _.isFunction(callback)){
                    callback(false);
                }

            }

        },

        getAllocation: function(account_id, load_fresh){
            var accounts = this.manage_allocations;

            for(var i = 0; i < accounts.length; i++){
                var account = accounts[i];
                if(account.account_id == account_id){
                    return account.allocation_percentage;
                }
            }

        },

        storeAllocation: function(account_id, percentage){
            var accounts = this.manage_allocations;

            for(var i = 0; i < accounts.length; i++){
                var account = accounts[i];
                if(account.account_id == account_id){
                    account.allocation_percentage = percentage;
                }
            }
        },

        getAllocations: function(callback){
            var that = this;

            that.allocations = [];
            that.manage_allocations = [];

            $.ajax({
                type       : 'GET',
                url        : pf.consumerURL + '/Allocations',
                contentType: 'application/json',
                success    : function(model, resp){

                    model.forEach(function(old_account){
                        var account = {
                            created_dt           : old_account.CDT,
                            image_name           : old_account.PN,
                            account_id           : old_account.AGID,
                            account_name         : old_account.AN,
                            account_type_id      : old_account.ATID,
                            target_amount        : old_account.TA,
                            manager_user_guid    : old_account.MUGD,
                            allocation_percentage: old_account.AP
                        };

                        that.allocations.push(account);

                        that.manage_allocations.push({
                            account_id           : account.account_id,
                            allocation_percentage: account.allocation_percentage
                        });

                    });

                    if(_.isFunction(callback)){
                        callback(that.allocations);
                    }
                },
                error      : function(err){
                    if(_.isFunction(callback)){
                        callback(false);
                    }
                }
            });

        },

        saveAllocations: function(callback){
            
            $.ajax({
                type       : 'PUT',
                url        : pf.userURL + 's/' + pf.session.get('UserGUID') + '/Allocations',
                data       : JSON.stringify(this.manage_allocations),
                contentType: 'application/json',
                success    : function(model, resp){
                    if(callback){
                        callback(true);
                    }
                },
                error      : function (err) {
                    if(callback){
                        callback(false);
                    }
                }
            });

        }

    });

    return AccountsContoller;
});
